import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { Toast } from 'primeng/toast';
import { ThemeService } from './app/services/theme.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '@/services/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, Toast],
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {
    private translate = inject(TranslateService);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private titleService = inject(Title);
    private themeService = inject(ThemeService);

    private sub = new Subscription();
    private siteTitle: string = '';
    private checkTokenInterval: any;
    private loggedIn = false;

    constructor(
        private config: PrimeNG,
        private authService: AuthService,
    ) {
        this.translate.addLangs(['de']);
        this.translate.setFallbackLang('de');

        this.translate.get('primeng').subscribe((res) => this.config.setTranslation(res));
        // site title from theme
        this.themeService.themeData.subscribe({ next: data => { this.siteTitle = data?.theme_title || ''; } });

        // update title on navigation
        this.sub.add(
            this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.updateTitle())
        );
    }

    ngOnInit(): void {
        this.authService.sessionData.subscribe({
            next: async (data) => {
                this.loggedIn = data.isLoggedIn;

                if (this.loggedIn && !this.checkTokenInterval) {

                    this.authService.checkAndRenewToken();
                    this.checkTokenInterval = setInterval(
                        () => {
                            this.authService.checkAndRenewToken();
                        },
                        1000 * 60 * 5,
                    );
                }
            },
        });

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private updateTitle() {
        // find deepest route
        let route = this.activatedRoute.firstChild;
        while (route?.firstChild) {
            route = route.firstChild;
        }

        const snapshot = route?.snapshot;
        let pageTitle = '';

        // compute URL once
        const fullUrl = this.router.url || '';

        if (snapshot?.data && snapshot.data['title']) {
            pageTitle = snapshot.data['title'];
            // detect admin area: route data can set area: 'admin' or fallback to URL check
            const isAdmin = snapshot.data['area'] === 'admin' || fullUrl.includes('/management') || fullUrl.includes('/admin');

            // try translate
            this.translate.get(pageTitle).subscribe(trans => {
                if (isAdmin) {
                    const title = `Admin - ${trans || pageTitle}`;
                    this.titleService.setTitle(title);
                } else {
                    const title = `${trans || pageTitle} - ${this.siteTitle || 'Qloc-Abrechnung'}`;
                    this.titleService.setTitle(title);
                }
            });
            return;
        }

        // fallback: last path segment
        const url = this.router.url || '';
        const parts = url.split('/').filter(p => p && !p.startsWith('?'));
        if (parts.length === 0) {
            pageTitle = this.siteTitle || 'Qloc-Abrechnung';
        } else {
            const last = parts[parts.length - 1];
            pageTitle = last.replace(/-/g, ' ');
            pageTitle = pageTitle.charAt(0).toUpperCase() + pageTitle.slice(1);
        }
    const isAdmin = fullUrl.includes('/management') || fullUrl.includes('/admin');
    const title = isAdmin ? `Admin - ${pageTitle}` : `${pageTitle} - ${this.siteTitle || 'Qloc-Abrechnung'}`;
        this.titleService.setTitle(title);
    }

}
